export const transformExtraServicePaymentDto = _ref => {
  let {
    id,
    status,
    pay_in_redirect_url,
    failure_reason
  } = _ref;
  return {
    id,
    status,
    payInRedirectUrl: pay_in_redirect_url,
    failureReason: failure_reason
  };
};